<div class="row justify-content-center align-items-center" mat-dialog-title>
    <div class="col-md-10 col-10">
        <h5 class="text-center txt-primario">Detalle cobertura</h5>
    </div>
    <div class="col-md-2 col-2 text-right">
        <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
    </div>
</div>
<mat-dialog-content class="py-0">
    <mat-card-content class="py-0">
        <div class="row">
            <div class="col-md-12">
                <strong>Suma Asegurada: </strong>
                <small>{{data.cobertura.suma_aseg}}</small>
            </div>
            <div class="col-md-12">
                <strong>Fecha estatus: </strong>
                <small>{{data.cobertura.fechast}}</small>
            </div>
            <div class="col-md-12">
                <strong>Fecha inicial: </strong>
                <small>{{data.cobertura.fechaini}}</small>
            </div>
            <div class="col-md-12">
                <strong>Fecha término: </strong>
                <small>{{data.cobertura.fechater}}</small>
            </div>
        </div>
    </mat-card-content>
</mat-dialog-content>
<mat-card-actions class="row mx-md-0 justify-content-md-end">
    <div class="col-md-auto col-auto">
        <button type="submit" color="primary" class="mx-1 my-1" mat-raised-button (click)="closeDialog('Aceptar')">
            Cerrar
        </button>
    </div>
</mat-card-actions>